import React from "react";
import { PageLayout, PageContent, PageHeader } from "../../ui";
import { TracesView } from "./components/TracesView";

export default function TracesPage() {
  return (
    <PageLayout>
      <PageContent maxWidth="full">
        <PageHeader
          title="Traces"
          description="Browse and inspect your evaluation traces"
        />
        <TracesView />
      </PageContent>
    </PageLayout>
  );
}
